module.exports = __webpack_public_path__ + "img/11.859af883.png";